import { VOICE_WALL_CSS } from "@noiman/ui/voice-wall";
/*
  第1段の節の CSS。ゆめさくエンジニアとは (AboutScope)、LearningPhases、PhaseDetail、
  VoicesShowcase、CostPerformance、締め (ClosingCta)。値は見本 b.html (案B) と c.html (案C) から写した。
  色と余白は hp-base.ts の変数を使う。ここに新しい値を直書きしない (表の中の薄い灰など、見本にあるものを除く)。
*/
export const ABOUT_VOICES_CSS = `
/* 難易度の色。基礎は青みの白、応用は青、実践は墨。ゆめさくとは の帯と、学ぶ中身の帯で同じ */
.hp .hx-lv-b{background:var(--blue-wash);color:var(--ink)}
.hp .hx-lv-a{background:var(--blue);color:#fff}
.hp .hx-lv-p{background:var(--ink);color:#fff}

/* ゆめさくエンジニアとは */
.hp .hx-about-name{display:flex;align-items:center;gap:10px;margin-top:16px}
.hp .hx-about-name img{height:auto;width:144px}
.hp .hx-about-name span{font-size:17px;font-weight:700;letter-spacing:.06em}
.hp .hx-about-h2{margin-top:16px}
.hp .hx-about-lede{margin-top:24px;max-width:640px;font-size:15px;line-height:1.9;color:var(--sub)}
.hp .hx-about-lede b{color:var(--ink);font-weight:700}
.hp .hx-scope{margin-top:var(--gap);max-width:880px}
.hp .hx-scope-row{display:flex;align-items:center;gap:12px}
.hp .hx-scope-gap{margin-top:20px}
.hp .hx-scope-track{display:flex;flex:1;flex-wrap:wrap;align-items:center;gap:4px 8px;min-width:0}
.hp .hx-scope-side{flex:1 0 100%;min-width:0;margin:0;font-size:12px;line-height:1.5;color:var(--sub)}
.hp .hx-scope-side b{display:block;font-size:12px;color:var(--ink)}
.hp .hx-scope-side small{display:block;font-size:12px}
.hp .hx-scope-other+.hx-scope-other{margin-top:12px}
.hp .hx-scope-short.hx-scope-flat{padding:0 10px}
.hp .hx-scope-other{align-items:flex-start}
.hp .hx-scope-other .hx-scope-lab{line-height:40px}
.hp .hx-scope-src{margin:14px 0 0 calc(4.5rem + 12px);font-size:12px;line-height:1.6;color:var(--sub)}
.hp .hx-scope-src p{margin:0}
.hp .hx-scope-src summary{cursor:pointer;margin-top:2px}
.hp .hx-scope-src ul{margin:4px 0 0;padding-left:1.2em}
.hp .hx-scope-src a{color:inherit;text-decoration:underline;overflow-wrap:anywhere}
.hp .hx-scope-short{flex:none;box-sizing:border-box;width:var(--w)}
.hp .hx-scope-lab{flex:none;width:4.5rem;text-align:right;font-size:12px;font-weight:700;color:var(--sub);font-variant-numeric:tabular-nums}
.hp .hx-scope-lab-us{color:var(--blue)}
.hp .hx-scope-short{display:flex;align-items:center;justify-content:center;min-height:40px;border:1px dashed var(--ink);background:var(--cream);padding:0 2px;overflow:hidden}
.hp .hx-scope-short span{font-size:12px;line-height:1.25;font-weight:700;color:var(--sub);text-align:center;overflow:hidden;word-break:auto-phrase}
/* 帯の列と目盛りは同じ 18 等分の格子を使う。minmax(0,1fr) なので、中の数字や盾が大きくても月の幅は等しいまま */
.hp .hx-scope-tr,.hp .hx-scope-ticks{display:grid;grid-template-columns:repeat(18,minmax(0,1fr))}
.hp .hx-scope-tr{flex:1;min-height:40px;border:1px solid var(--ink);background:#fff;min-width:0}
.hp .hx-scope-tr>span{grid-column:var(--gc);min-width:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;padding:6px 2px;border-right:1px solid var(--ink);overflow:hidden;white-space:nowrap}
.hp .hx-scope-tr>span:last-child{border-right:0}
.hp .hx-scope-tr>span.hx-scope-in{border-right-color:color-mix(in srgb,currentColor 30%,transparent)}
.hp .hx-scope-badge{display:block;width:100%;max-width:40px;height:auto}
.hp .hx-scope-ph{display:inline-block}
.hp .hx-scope-ix{display:none;--font-body-ja:var(--mono);font-size:12px;font-weight:600}
.hp .hx-scope-cap{margin:6px 0 0 calc(4.5rem + 12px);font-size:12px;line-height:1.6;color:var(--sub)}
.hp .hx-scope-cap-us b{display:block;font-size:13px;color:var(--ink)}
.hp .hx-scope-ruler{margin-top:4px;gap:12px}
/* 目盛りの数字は 1 か月の幅 (100cqi の 18 分の 1) の 7 割まで。二桁が 1 行に入り、文字を拡大しても月の幅を押し広げない */
.hp .hx-scope-ticks{flex:1;min-width:0;padding:0 1px;container-type:inline-size}
.hp .hx-scope-ticks span{min-width:0;text-align:center;white-space:nowrap;font-size:clamp(7px,calc(100cqi / 18 * .7),12px);line-height:1;padding-top:5px;color:var(--sub);border-left:1px solid #c9c9bd;height:12px;box-sizing:content-box;font-variant-numeric:tabular-nums}
.hp .hx-scope-ticks span.hx-scope-tick-s{border-left-color:var(--ink)}
.hp .hx-scope-ticks span:last-child{border-right:1px solid var(--ink)}
.hp .hx-scope-cards{list-style:none;margin:14px 0 0;padding:0;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:8px}
.hp .hx-scope-cards li{display:flex;flex-direction:column;gap:4px;padding:8px 10px;border:1px solid var(--ink)}
.hp .hx-scope-ch{display:flex;align-items:center;gap:6px;min-width:0}
.hp .hx-scope-cb{flex:none;display:block;width:auto;height:20px}
.hp .hx-scope-cx{display:none;flex:none;--font-body-ja:var(--mono);font-size:12px;font-weight:600}
.hp .hx-scope-cn{min-width:0;overflow-wrap:anywhere;font-size:13px;font-weight:700;line-height:1.35}
.hp .hx-scope-cards small{font-size:12px;font-weight:600;opacity:.85;font-variant-numeric:tabular-nums}
.hp .hx-scope-cards .hx-scope-tags{display:flex;flex-wrap:wrap;gap:4px;margin-top:2px}
.hp .hx-scope-tags i{font-style:normal;font-size:12px;font-weight:600;line-height:1.3;padding:2px 6px;border:1px solid var(--ink);background:#fff;color:var(--ink);white-space:nowrap}
@media (min-width:768px){
  .hp .hx-scope-short span{font-size:12px;white-space:nowrap}
  .hp .hx-about-name img{width:176px}
  .hp .hx-about-name span{font-size:20px}
  .hp .hx-scope-lab{width:5.5rem}
  .hp .hx-scope-cap,.hp .hx-scope-src{margin-left:calc(5.5rem + 12px)}
  .hp .hx-scope-other{align-items:center}
  .hp .hx-scope-track{flex-wrap:nowrap}
  .hp .hx-scope-side{flex:1 1 0}
  .hp .hx-scope-ruler{gap:12px}
}
/* 768px 以上の帯は、9 列すべてに並びの番号 (札の見出しにも同じ番号)。768px 未満は帯も札も盾で対応させる。名前と期間と中身は下の札で読む (帯の中に名前を出すと 1ヶ月の列で切れるか縦書きになる) */
@media (min-width:768px){
  .hp .hx-scope-ix{display:block}
  /* 盾の箱の高さをそろえ、細い列の盾が小さくても番号の高さが列ごとにずれないようにする */
  .hp .hx-scope-badge{height:42px;object-fit:contain}
  .hp .hx-scope-cb{display:none}
  .hp .hx-scope-cx{display:block}
}
/* 札は 1200px 以上で 3 列 */
@media (min-width:1200px){
  .hp .hx-scope-cards{grid-template-columns:repeat(3,minmax(0,1fr))}
}

/* 18ヶ月で、何をどの順番で学ぶのか。帯 */
.hp .hx-span{margin-top:var(--gap)}
.hp .hx-span-tr{display:flex;height:44px;border:1px solid var(--ink);background:#fff}
.hp .hx-span-tr>span{--font-body-ja:var(--mono);display:flex;align-items:center;padding:0 8px;border-right:1px solid var(--ink);font-size:12px;font-weight:600;overflow:hidden;white-space:nowrap}
.hp .hx-span-tr>span:last-child{border-right:0}
.hp .hx-span-sc{display:flex;justify-content:space-between;margin-top:6px;font-size:12px;color:var(--sub)}
.hp .hx-span-ms{margin-top:6px;font-size:13px;font-weight:700}

/* 学ぶ中身。学習サイトの実物の形 */
.hp .hx-pd{padding-top:var(--gap)}
.hp .hx-pd-body{display:grid;grid-template-columns:minmax(0,1fr)}
.hp .hx-pd-tabs{display:flex;gap:8px;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;padding:12px;border-bottom:1px solid var(--ink);background:var(--cream)}
.hp .hx-pd-tab{position:relative;flex:none;overflow:hidden;text-align:left;font:inherit;background:#fff;color:var(--ink);border:1px solid var(--ink);border-radius:6px;padding:8px 12px;cursor:pointer;line-height:1.4}
.hp .hx-pd-tab-m{display:block;font-size:12px;font-weight:700;color:var(--sub)}
.hp .hx-pd-tab-t{display:block;font-size:13px;font-weight:700;white-space:nowrap}
.hp .hx-pd-tab[aria-current=true]{background:var(--ink);color:#fff}
@media (hover:hover){.hp .hx-pd-tab:not([aria-current=true]):hover{background:var(--blue-wash);border-color:var(--blue)}}
.hp .hx-pd-tab[aria-current=true] .hx-pd-tab-m{color:rgba(255,255,255,.8)}
.hp .hx-pd-prog{position:absolute;left:12px;right:12px;bottom:3px;height:2px;transform-origin:left;background:rgba(255,255,255,.55)}
.hp .hx-pd-panel{min-width:0;padding:20px 16px 8px}
.hp .hx-pd-top{display:flex;gap:14px;align-items:flex-start}
.hp .hx-pd-ico{flex:none;width:44px;height:44px;color:var(--ink)}
.hp .hx-pd-ico svg{display:block}
.hp .hx-pd-meta{font-size:12px;font-weight:700;color:var(--blue)}
.hp .hx-pd-h3{margin:0;font-weight:900;font-size:clamp(20px,5.6vw,26px);line-height:1.4;letter-spacing:-.02em}
.hp .hx-pd-sum{margin-top:12px;font-size:14px}
.hp .hx-pd-can{display:flex;gap:8px;margin-top:12px;font-weight:700;font-size:14px}
.hp .hx-pd-can::before{content:"";flex:none;width:16px;height:16px;margin-top:5px;background:var(--blue);clip-path:polygon(0 55%,12% 43%,38% 66%,86% 12%,100% 25%,38% 92%)}
.hp .hx-pd-stack{display:flex;flex-wrap:wrap;gap:6px;margin-top:14px}
.hp .hx-pd-stack span{border:1px solid var(--ink);padding:0 8px;font-size:12px;font-weight:700;line-height:1.7}
.hp .hx-pd-ms{display:inline-block;margin-top:14px!important;padding:0 8px;border:1px solid var(--blue);color:var(--blue);font-size:12px;font-weight:700;line-height:1.7}
.hp .hx-pd-shot{margin:20px 0 0;border:1px solid var(--ink);border-radius:6px;overflow:hidden}
.hp .hx-pd-shot img{display:block;width:100%;height:auto;max-height:340px;object-fit:cover;object-position:top}
.hp .hx-pd-shot figcaption{padding:6px 10px;border-top:1px solid var(--ink);font-size:12px;color:var(--sub);background:#fff}
.hp .hx-pd-ch{margin-top:20px;border-top:1px solid var(--ink)}
.hp .hx-pd-row{display:grid;gap:6px;padding:14px 0;border-bottom:1px solid var(--line)}
.hp .hx-pd-row:last-child{border-bottom:0}
.hp .hx-pd-ct{font-weight:900;font-size:14px;line-height:1.5}
.hp .hx-pd-ct span{display:block;font-size:12px;font-weight:700;color:var(--sub)}
.hp .hx-pd-row ul{margin:0;padding:0;list-style:none}
.hp .hx-pd-row li{display:flex;gap:8px;align-items:flex-start;margin-top:4px;font-size:13px;line-height:1.7}
.hp .hx-kd{flex:none;margin-top:3px;padding:0 6px;border:1px solid var(--ink);font-size:12px;font-weight:700;line-height:1.6}
.hp .hx-kd-p{background:var(--blue);border-color:var(--blue);color:#fff}
.hp .hx-kd-h{background:var(--ink);color:#fff}
.hp .hx-pd-total{padding:12px 16px;border-top:1px solid var(--ink);background:var(--cream);font-size:13px}
.hp .hx-pd-total b{--font-body-ja:var(--mono);font-weight:600}
.hp .hx-pd-band{margin-top:var(--sec)}
/* 明るい服の上でも白い字が読めるよう、字の下に暗い半透明の帯を敷く (比 4.5 以上) */
.hp .hx-pd-band .hx-band-in{bottom:0;padding:28px 0 24px;background:linear-gradient(to bottom,rgba(0,0,0,0),rgba(0,0,0,.45) 24px)}
@media (min-width:768px){.hp .hx-pd-band .hx-band-in{padding-bottom:40px}}
/* grid にすると、Safari は枠より広い iframe の負の左の余白を捨てて右へ寄せる。block にして間は margin で取る */
.hp .hx-pd-map{margin:var(--sec) 0 0;display:block}
.hp .hx-pd-map > * + *{margin-top:8px}
.hp .hx-pd-map-h{margin:0;font-size:16px;font-weight:900;line-height:1.5}
.hp .hx-pd-map-p{margin:0;font-size:13px;line-height:1.7;color:var(--sub)}
.hp .hx-pd-map-if{display:block;width:100%;height:560px;border:0;background:transparent;color-scheme:light}
@media (min-width:640px){.hp .hx-pd-map-if{--mw:min(1160px,calc(100vw - 48px));width:var(--mw);max-width:none;margin-left:calc((100% - var(--mw)) / 2);height:680px}}
@media (min-width:1024px){.hp .hx-pd-map-if{height:632px}}
.hp .hx-pd-map-n{font-size:12px;line-height:1.6;color:var(--sub)}
@media (min-width:900px){
  .hp .hx-pd-body{grid-template-columns:280px minmax(0,1fr)}
  .hp .hx-pd-tabs{flex-direction:column;overflow:visible;border-bottom:0;border-right:1px solid var(--ink);padding:16px}
  .hp .hx-pd-tab-t{white-space:normal}
  .hp .hx-pd-panel{padding:32px 36px 16px}
  .hp .hx-pd-cols{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,.9fr);gap:36px;align-items:start}
  .hp .hx-pd-shot{margin-top:0}
  .hp .hx-pd-row{grid-template-columns:30% minmax(0,1fr);gap:24px}
  .hp .hx-pd-row li{margin-top:0;padding:4px 0}
}

/* 受講生の声。数で見せる。実数の札、声の札・映像は、どれも1行の横スクロール (投稿の壁だけは流す) (右端を見切れさせ、矢印でも送れる)。余白はこの節だけ詰める */
.hp .hx-voices{--sec:36px;--gap:20px;overflow-x:clip}
.hp .hx-vhead{display:grid;gap:var(--gap)}
.hp .hx-vnums{margin:0;padding:0;list-style:none;display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}
.hp .hx-vnums li{display:grid;gap:4px;align-content:start;border-top:1px solid var(--ink);padding-top:12px}
.hp .hx-vnum{--font-body-ja:var(--mono);display:flex;align-items:baseline;font-size:clamp(32px,9vw,40px);font-weight:600;line-height:1.1;letter-spacing:-.04em;font-variant-numeric:tabular-nums}
.hp .hx-vnum-ic{flex:none;align-self:center;margin-right:6px;color:var(--ink)}
.hp .hx-vnum small{--font-body-ja:var(--gothic);font-size:max(12px,.4em);font-weight:700;letter-spacing:0;margin-left:1px}
.hp .hx-vnum-l{font-size:12px;font-weight:700;line-height:1.5;word-break:auto-phrase;text-wrap:pretty}
.hp .hx-vcards{margin:8px -20px 0;padding:0 20px 6px;list-style:none;display:flex;gap:12px;align-items:stretch;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;scroll-padding-left:20px;scrollbar-width:thin}
.hp .hx-vcards:has(details[open]){align-items:start}
.hp .hx-vcards>li{display:block;flex:none;width:158px;min-width:0;scroll-snap-align:start}
.hp .hx-vc{height:100%;border:1px solid var(--ink);border-radius:6px;background:#fff;overflow:hidden}
.hp .hx-vc[open]{border-color:var(--blue)}
.hp .hx-vc>summary{display:block;list-style:none;cursor:pointer}
.hp .hx-vc>summary::-webkit-details-marker{display:none}
.hp .hx-vc>summary:focus-visible{outline:2px solid var(--focus-ring);outline-offset:-2px}
.hp .hx-vc-art{display:flex;align-items:center;justify-content:center;aspect-ratio:16/4.4;position:relative;border-bottom:1px solid var(--ink);background:var(--cream);color:var(--ink);overflow:hidden}
/* 映像の絵には、上の端に旧い名前の札 (Luagateスタッフ) と、下の 4 割ほどに字幕が焼き込まれている。
   札と字幕が入らない、絵の高さの 23〜57% だけを見せる。帯の高さから見える割合が決まるので、拡大して中心を 40% に置く (SP は 1.5 倍、768 から 2 倍) */
.hp .hx-vc-art img{display:block;width:100%;height:100%;object-fit:cover;object-position:50% 30%;transform:scale(1.5);transform-origin:50% 50%}
.hp .hx-vc-art svg{display:block;width:30px;height:30px}
.hp .hx-vc-h{--font-body-ja:var(--mincho);display:block;padding:8px 10px 0;font-weight:700;font-size:15px;line-height:1.4;letter-spacing:.01em;word-break:auto-phrase;text-wrap:pretty}
.hp .hx-vc-who{display:block;padding:4px 10px 8px;font-size:12px;line-height:1.5;color:var(--sub);word-break:auto-phrase;text-wrap:balance}
.hp .hx-vc-pm{position:absolute;top:5px;right:5px;width:20px;height:20px;border:1px solid var(--ink);border-radius:4px;background:#fff}
.hp .hx-vc-pm::before,.hp .hx-vc-pm::after{content:"";position:absolute;left:50%;top:50%;background:var(--ink);transform:translate(-50%,-50%)}
.hp .hx-vc-pm::before{width:10px;height:2px}
.hp .hx-vc-pm::after{width:2px;height:10px}
.hp .hx-vc[open] .hx-vc-pm::after{display:none}
.hp .hx-vc-full{padding:10px;border-top:1px solid var(--line)}
.hp .hx-vc-tp{margin:0;font-size:12px;font-weight:700;line-height:1.5;color:var(--blue)}
.hp .hx-vc-tp::before{content:"";display:inline-block;width:8px;height:8px;margin-right:8px;background:var(--blue)}
.hp .hx-vc-full blockquote{margin:6px 0 0;font-size:13px;line-height:1.85}
.hp .hx-vc-full strong{font-weight:900;background:linear-gradient(transparent 70%,#BFD1F7 70%)}
.hp .hx-nb-lede{margin:8px 0 0;font-size:13px;font-weight:700;line-height:1.7}
/* 受講生の投稿の壁 (VoiceWall) の CSS は @noiman/ui/voice-wall と共有 (適職診断の結果と同じ物)。ここは HP の色と余白の変数だけ。
   壁の左右は本文の余白ぶん (狭いときは padding の 20px) 画面の端まで伸ばし、次の 1 枚を見切れさせる */
${VOICE_WALL_CSS}
.hp{--vw-ink:var(--ink);--vw-sub:var(--sub);--vw-line:var(--line);--vw-soft:var(--cream);--vw-hover:var(--blue);--vw-focus:var(--focus-ring);--vw-mono:var(--mono);--vw-bleed:20px}
.hp .vw-wall{margin-top:14px}
@media (min-width:768px){.hp{--vw-bleed:max(20px,(100vw - 1040px) / 2)}}
.hp .hx-vf-hd{display:flex;flex-wrap:wrap;align-items:baseline;justify-content:space-between;gap:4px 16px;margin-top:var(--gap);padding-top:12px;border-top:1px solid var(--ink)}
.hp .hx-vf-t{margin:0;display:flex;flex-wrap:wrap;align-items:baseline;gap:2px 10px;font-weight:900;font-size:15px;line-height:1.5}
.hp .hx-vf-name{white-space:nowrap}
.hp .hx-vf-sub{font-weight:700;font-size:12px;color:#5b5b55}
.hp .hx-vf-links{margin:0;display:flex;flex-wrap:wrap;gap:4px 16px}
.hp .hx-vf-more{font-size:13px}
.hp .hx-vfilms{margin:12px -20px 0;padding:0 20px 4px;list-style:none;display:flex;gap:12px;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;scroll-padding-left:20px}
.hp .hx-vfilms>.hx-vf{flex:none;width:64%;max-width:280px;scroll-snap-align:start}
.hp .hx-vfilms>.hx-vf-on{order:0;width:88%;max-width:420px;margin:0}
.hp .hx-vf{min-width:0}
.hp .hx-vf-box{position:relative;border:1px solid var(--ink);border-radius:6px;overflow:hidden;background:#000}
.hp .hx-vf-box>div{padding-top:50%}
/* 映像の札の絵も同じ。2.5:1 に低くして、2.2 倍に拡大した 24〜56% を見せる。再生中 (hx-vf-on) は映像そのもの */
.hp .hx-vf:not(.hx-vf-on) .hx-vf-box>div{padding-top:40%}
.hp .hx-vf-box img[src*="vumbnail"]{object-position:50% 15%;transform:scale(2.2);transform-origin:50% 50%}
/* 1185117557 (フリーランスデザイナー) は札も字幕も無い題の絵 (自己紹介) なので、そのまま見せる */
/* YouTube の絵は下に題の字が入っている。下の名前の帯と重ならないよう、上下の黒い帯を避けつつ絵を上に寄せて、下の字の段を外へ出す */
.hp .hx-vf:not(.hx-vf-on) .hx-vf-box img[src*="ytimg"]{object-position:50% 31%;transform:scale(1.14);transform-origin:60% 0}
.hp .hx-vf-box img[src*="1185117557"]{object-position:50% 50%;transform:none}
.hp .hx-vf-on .hx-vf-box>div{padding-top:56.25%}
.hp .hx-vf-box button>div>div{width:32px;height:32px}
.hp .hx-vf-box button svg{width:14px;height:14px}
.hp .hx-vf-box button>div{align-items:flex-start;padding-top:8px}
.hp .hx-vf-cap{position:absolute;left:0;right:0;bottom:0;padding:16px 8px 6px;pointer-events:none;background:linear-gradient(to top,rgba(14,14,16,.88),rgba(14,14,16,0));color:#fff;font-size:12px;font-weight:700;line-height:1.4}
.hp .hx-vf-name{margin:8px 0 0;font-size:13px;font-weight:700;line-height:1.5}
@media (min-width:768px){
  /* 横の列は、右端を画面の端まで伸ばして次の1枚を見切れさせる。伸ばす量は本文の右の余白ぶん (狭いときは padding の 20px) */
  .hp .hx-vcards,.hp .hx-vfilms{gap:16px;margin-left:0;margin-right:calc(-1 * max(20px,(100vw - 1040px) / 2));padding-left:0;padding-right:20px;scroll-padding-left:0}
  .hp .hx-vcards>li{width:236px}
  .hp .hx-vfilms>.hx-vf,.hp .hx-vfilms>.hx-vf-on{width:330px;max-width:none}
  .hp .hx-vfilms>.hx-vf-on{width:520px}
  .hp .hx-vc-art{aspect-ratio:16/6}
  .hp .hx-vc-art img{object-position:50% 20%;transform:scale(2)}
  .hp .hx-vc-art svg{width:56px;height:56px}
  .hp .hx-vf-box>div{padding-top:46%}
  .hp .hx-vc-full{padding:12px 12px 14px}
  .hp .hx-vf-box button>div>div{width:44px;height:44px}
  .hp .hx-vf-box button svg{width:18px;height:18px}
  .hp .hx-vf-box button>div{align-items:center;padding-top:0}
}
@media (min-width:900px){
  .hp .hx-vc-h{padding:10px 14px 0;font-size:17px}
  .hp .hx-vc-who{padding:6px 14px 12px;font-size:12px}
  .hp .hx-vf-cap{padding:20px 10px 8px;font-size:12px}
  .hp .hx-voices{--sec:48px;--gap:24px}
  .hp .hx-vhead{grid-template-columns:minmax(0,1fr) minmax(0,460px);align-items:end;gap:48px}
  .hp .hx-vnums{gap:24px}
  .hp .hx-vnum{font-size:52px}
  .hp .hx-vnum-l{font-size:13px}
}
/* インタビュー映像は、タブレット以上で横に流さず格子にする。本数で列を決めず、2列 (768以上) と3列 (900以上) の自動配置にする。
   押した1本は大きくせず、同じ札の中で再生する (大きくすると段の高さが動く)。矢印は流す列が無いので隠す */
@media (min-width:768px){
  .hp .hx-vfilms{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:20px 16px;margin:12px 0 0;padding:0;overflow:visible;scroll-snap-type:none}
  .hp .hx-vfilms>.hx-vf,.hp .hx-vfilms>.hx-vf-on{width:auto;max-width:none;min-width:0}
  .hp .hx-vf-on .hx-vf-box>div{padding-top:46%}
  .hp .hx-arrs-film{display:none}
}
@media (min-width:900px){
  .hp .hx-vfilms{grid-template-columns:repeat(3,minmax(0,1fr));gap:24px 20px}
}

`;

// 字の下の黄のマーカー。料金と受講生の声のページも使う
export const HL_CSS = `/* 料金と比べ */
.hp .hx-hl{background:linear-gradient(transparent 60%,#FFE566 60%);color:inherit;box-decoration-break:clone;-webkit-box-decoration-break:clone}
`;

export const PLANS_CSS = `/* プランごとの期間の帯。黒の18ヶ月は3本で同じ長さ、黄が卒業後。生涯は右端を閉じず矢印で先へ続く。影なし */
.hp .hx-pb{list-style:none;display:grid;gap:14px;margin:var(--gap) 0 0;padding:0}
.hp .hx-pb-row{display:grid;gap:6px}
.hp .hx-pb-nm{margin:0;display:flex;align-items:center;gap:8px;font-size:14px;font-weight:900;line-height:1.4}
.hp .hx-pb-nm em{padding:1px 8px;background:var(--yellow);color:var(--ink);font-size:12px;font-style:normal;font-weight:900;line-height:1.6;border-radius:3px;white-space:nowrap}
.hp .hx-pb-track{display:flex;align-items:stretch;height:52px}
.hp .hx-pb-track>div:not(.hx-pb-arrow){display:flex;flex-direction:column;justify-content:center;min-width:0;padding:0 10px;line-height:1.3;border:1px solid var(--ink);white-space:nowrap}
.hp .hx-pb-a{background:var(--ink);color:#fff;border-radius:6px 0 0 6px}
.hp .hx-pb-b{background:var(--yellow);color:var(--ink);border-left:0;border-radius:0 6px 6px 0}
.hp .hx-pb-a:last-child{border-radius:6px}
.hp .hx-pb-open{flex:1 1 0;border-right:0;border-radius:0}
.hp .hx-pb-arrow{flex:none;width:0;height:0;margin:-1px 0;border-top:27px solid transparent;border-bottom:27px solid transparent;border-left:18px solid var(--ink)}
.hp .hx-pb-track b{font-size:15px;font-weight:900}
.hp .hx-pb-track i{--font-body-ja:var(--mono);font-style:normal;font-weight:600;margin-right:1px}
.hp .hx-pb-track span{font-size:12px}
.hp .hx-pb-sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}
.hp .hx-pb-row{position:relative}
@media (min-width:640px){
  .hp .hx-pb-row{grid-template-columns:208px minmax(0,1fr);align-items:center;gap:16px}
  .hp .hx-pb-track b{font-size:16px}
  .hp .hx-pb-track span{font-size:12px}
}
.hp .hx-incl-sum{margin-top:var(--gap);padding-top:16px;border-top:1px solid var(--ink);font-size:15px}
.hp .hx-incl-sum b{font-weight:900}
`;

// 開閉の部品。受講生の声のページも使う
export const DT_CSS = `/* 開閉の部品。印は CSS で描く。押す高さは 48px */
.hp .hx-dt{border-top:1px solid var(--ink);border-bottom:1px solid var(--ink)}
.hp .hx-dt>summary{display:flex;align-items:center;justify-content:space-between;gap:12px;min-height:48px;padding:8px 0;cursor:pointer;list-style:none;font-weight:900;font-size:16px;line-height:1.5}
.hp .hx-dt>summary::-webkit-details-marker{display:none}
.hp .hx-dt>summary::after{content:"";flex:none;width:14px;height:14px;background:linear-gradient(var(--ink),var(--ink)) center/100% 2px no-repeat,linear-gradient(var(--ink),var(--ink)) center/2px 100% no-repeat}
.hp .hx-dt[open]>summary::after{background:linear-gradient(var(--ink),var(--ink)) center/100% 2px no-repeat}
.hp .hx-dt>summary:focus-visible{outline:2px solid var(--focus-ring);outline-offset:2px}
`;

// 給付金の箱
export const GRANT_CSS = `.hp .hx-grant{margin-top:var(--gap);padding:20px 16px;border:1px solid var(--ink);border-radius:6px;background:#fff}
.hp .hx-grant-t{display:flex;align-items:center;gap:6px;margin-top:4px;font-weight:900;font-size:16px;line-height:1.5}
.hp .hx-grant-ic{flex:none}
.hp .hx-grant-flow{display:grid;grid-template-columns:1.3fr auto 1fr auto 1fr;align-items:stretch;gap:2px;margin:10px 0 0;padding:0;list-style:none;font-size:12px;line-height:1.45;text-align:center}
.hp .hx-grant-flow li{display:flex;align-items:center;justify-content:center}
.hp .hx-grant-flow li:nth-child(odd){padding:6px 2px;border:1px solid var(--ink);border-radius:4px;background:#F6F7F9}
.hp .hx-grant-flow b{font-weight:900}
.hp .hx-grant-flow .hx-nw{display:inline-block}
.hp .hx-grant-h{margin-top:4px;font-size:14px;font-weight:700}
.hp .hx-grant-h span{display:inline-block}
.hp .hx-grant-b{margin-top:8px;font-size:13px}
.hp .hx-grant-b b{font-weight:700}

`;

// 締めの申し込みの面 (ClosingCta)。下層のページの末尾 (PageEndCta) も使う
export const CLOSING_CSS = `/* 締めの申し込みの面。ブランド広告の黒 */
.hp .hx-end{--font-body-ja:var(--gothic);padding-top:0;padding-bottom:40px;word-break:keep-all;overflow:hidden}
.hp .hx-end-top{position:relative;margin-bottom:32px}
.hp .hx-end-photo{position:relative;height:240px;overflow:hidden;pointer-events:none}
.hp .hx-end-photo img{display:block;width:100%;height:100%;object-fit:cover;object-position:50% 18%}
.hp .hx-end-photo::after{content:"";position:absolute;inset:0;background:linear-gradient(180deg,rgba(14,14,16,0) 35%,var(--black) 100%)}
.hp .hx-end-top .hx-wrap{position:relative;margin-top:-36px}
.hp .hx-end-grid{display:grid;grid-template-columns:minmax(0,1fr);gap:32px}
.hp .hx-end .hx-h2{--font-body-ja:var(--mincho);line-height:1.5;letter-spacing:.08em;margin:0}
.hp .hx-end-p{margin-top:18px;max-width:560px;font-size:15px;line-height:1.9;letter-spacing:.04em;color:rgba(255,255,255,.9)}
.hp .hx-end-p b{font-weight:700;color:#fff}
.hp .hx-end-cta{margin-top:28px}
`;

// 墨の面の中の窓の枠。30日チャレンジの墨の節も使う
export const DARK_FRAME_CSS = `.hp .hx-dark .hx-frame{border-color:rgba(255,255,255,.4)}
.hp .hx-dark .hx-frame-bar{border-bottom-color:rgba(255,255,255,.4)}
.hp .hx-dark .hx-frame-bar i{border-color:var(--ink)}
`;

export const CLOSING_FLOW_CSS = `.hp .hx-end-note{margin:12px 0 0;max-width:560px;font-size:12px;line-height:1.7;letter-spacing:.04em;color:rgba(255,255,255,.7)}
.hp .hx-end-contact{color:#fff;text-decoration:underline;text-underline-offset:3px;margin:0 2px}
@media (max-width:767px){.hp .hx-end-contact{display:inline-block;padding:14px 2px;margin:-14px 2px}}
.hp .hx-end-flow{list-style:none;margin:0;padding:0;display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:18px 22px}
.hp .hx-end-step{position:relative;display:flex;flex-direction:column;min-width:0;border:1px solid rgba(255,255,255,.4);border-radius:6px;background:rgba(255,255,255,.07)}
.hp .hx-end-pic{margin:0;position:relative;aspect-ratio:16/9;border-radius:5px 5px 0 0;overflow:hidden;background:rgba(255,255,255,.08);border-bottom:1px solid rgba(255,255,255,.28)}
.hp .hx-end-pic img{display:block;width:100%;height:100%;object-fit:cover}
.hp .hx-end-no{position:absolute;left:8px;top:8px;min-width:28px;height:22px;padding:0 6px;box-sizing:border-box;border:1px solid rgba(255,255,255,.7);border-radius:999px;display:grid;place-items:center;font-size:12px;font-weight:700;letter-spacing:.04em;color:#fff;background:var(--ink)}
.hp .hx-end-no-line{border-color:#06C755;color:#06C755}
.hp .hx-end-body{padding:10px 12px 12px;min-width:0}
.hp .hx-end-flow b{display:flex;flex-wrap:wrap;align-items:center;gap:2px 6px;font-size:14px;line-height:1.5;color:#fff}
.hp .hx-end-ic{display:block;margin-bottom:6px;--icon-paper:transparent}
.hp .hx-end-flow p{margin:2px 0 0;font-size:12px;line-height:1.5;letter-spacing:.02em;color:rgba(255,255,255,.82)}
.hp .hx-end-opt{font-style:normal;font-size:12px;font-weight:700;padding:0 7px;border:1px solid rgba(255,255,255,.6);border-radius:999px;letter-spacing:.06em}
.hp .hx-end-more{font-size:12px;font-weight:400;color:rgba(255,255,255,.85);text-decoration:underline;text-underline-offset:3px}
.hp .hx-end-step::after{position:absolute;color:rgba(255,255,255,.9);font-size:15px;line-height:1;pointer-events:none}
.hp .hx-end-step:nth-child(odd):not(:last-child)::after{content:"→";right:-19px;top:28%}
.hp .hx-end-step:nth-child(even)::after{content:"↓";left:50%;bottom:-17px;transform:translateX(-50%)}
.hp .hx-end-step:nth-child(5){grid-column:1 / -1;flex-direction:row}
.hp .hx-end-step:nth-child(5) .hx-end-pic{flex:0 0 42%;aspect-ratio:auto;border-radius:5px 0 0 5px;border-bottom:0;border-right:1px solid rgba(255,255,255,.28)}
.hp .hx-end-step:nth-child(5) .hx-end-body{align-self:center}
.hp .hx-end-step:nth-child(5):not(:last-child)::after{content:"↓";left:50%;right:auto;top:auto;bottom:-17px;transform:translateX(-50%)}
.hp .hx-end-step:nth-child(6)::after{content:"→";left:auto;right:-19px;top:28%;bottom:auto;transform:none}
/* 06 と 07 はスマホでは画像を省き、図記号と番号だけの札にして節の高さを抑える */
.hp .hx-end-step:nth-child(n+6) .hx-end-pic{aspect-ratio:auto;height:0;border:0;overflow:visible}
.hp .hx-end-step:nth-child(n+6) .hx-end-pic img{display:none}
.hp .hx-end-step:nth-child(n+6) .hx-end-no{left:auto;right:8px}
.hp .hx-end-sign{padding-top:18px;border-top:1px solid rgba(255,255,255,.28)}
@media (min-width:900px){
  .hp .hx-end{padding-bottom:48px}
  .hp .hx-end-top{padding:120px 0 24px;margin-bottom:24px}
  .hp .hx-end-photo{position:absolute;top:0;right:max(0px,calc(50% - 640px));bottom:0;width:min(46%,560px);height:auto}
  .hp .hx-end-photo img{object-position:50% 14%}
  .hp .hx-end-photo::after{background:linear-gradient(90deg,var(--black) 0%,rgba(14,14,16,.6) 28%,rgba(14,14,16,0) 62%),linear-gradient(180deg,var(--black) 0%,rgba(14,14,16,0) 14%,rgba(14,14,16,0) 80%,var(--black) 100%)}
  .hp .hx-end-top .hx-wrap{margin-top:0}
  .hp .hx-end-grid{grid-template-columns:minmax(0,1fr);row-gap:48px}
  .hp .hx-end-p{font-size:16px}
  .hp .hx-end-sign{grid-column:1 / -1}
  .hp .hx-end-flow{grid-template-columns:repeat(4,minmax(0,1fr));gap:28px 32px}
  .hp .hx-end-step:nth-child(5){grid-column:auto;flex-direction:column}
  .hp .hx-end-step:nth-child(5) .hx-end-pic{flex:none;aspect-ratio:16/9;border-radius:5px 5px 0 0;border-right:0;border-bottom:1px solid rgba(255,255,255,.28)}
  .hp .hx-end-step:nth-child(n+6) .hx-end-pic{aspect-ratio:16/9;height:auto;overflow:hidden;border-bottom:1px solid rgba(255,255,255,.28)}
  .hp .hx-end-step:nth-child(n+6) .hx-end-pic img{display:block}
  .hp .hx-end-step:nth-child(n+6) .hx-end-no{left:8px;right:auto}
  .hp .hx-end-step:nth-child(n):not(:last-child)::after{content:"→";left:auto;bottom:auto;transform:none;right:-22px;top:26%}
  .hp .hx-end-step:nth-child(4)::after{display:none}
  .hp .hx-end-flow b{font-size:15px}
  .hp .hx-end-flow p{font-size:12.5px}
  .hp .hx-end-note{font-size:13px}
}
@media (min-width:1100px){
  .hp .hx-end-flow{grid-template-columns:repeat(7,minmax(0,1fr));gap:0 20px}
  .hp .hx-end-step:nth-child(4)::after{display:block}
  .hp .hx-end-step:nth-child(n):not(:last-child)::after{right:-18px;top:22%}
  .hp .hx-end-body{padding:8px 7px 10px}
  .hp .hx-end-flow b{font-size:12.5px;word-break:auto-phrase;overflow-wrap:anywhere}
  .hp .hx-end-flow p{font-size:12px;word-break:auto-phrase;overflow-wrap:anywhere}
}
/* 7段の絵 (サムネの絵柄) は 16:9 のまま全体を見せる。判子とキャラを切らない */
.hp .hx-end-pic-art img{object-fit:contain}
/* 矢印の帯はスマホの横の列だけ */
.hp .hx-arrbar.hx-arrbar-sp{display:flex;justify-content:flex-end;margin:0 0 12px}
@media (min-width:768px){.hp .hx-arrbar.hx-arrbar-sp{display:none}}
/* スマホ (768px 未満) は縦に積まず、横に送る1行にする。右に次の札が少し覗く。7段とも同じ形 (絵、番号、図記号、名前、説明) にそろえ、段の間の矢印の字は出さない (番号と並びで順が分かる) */
@media (max-width:767px){
  .hp .hx-end-flow[data-hx-row]{display:flex;gap:12px;margin:0 -20px;padding:0 20px 8px;overflow-x:auto;overflow-y:hidden;overscroll-behavior-x:contain;scroll-snap-type:x mandatory;scroll-padding-left:20px;scrollbar-width:thin}
  .hp .hx-end-flow[data-hx-row]>.hx-end-step{flex:none;width:min(64vw,248px);flex-direction:column;scroll-snap-align:start}
  .hp .hx-end-flow[data-hx-row]>.hx-end-step::after{display:none}
  .hp .hx-end-flow[data-hx-row]>.hx-end-step .hx-end-pic,.hp .hx-end-flow[data-hx-row]>.hx-end-step:nth-child(n) .hx-end-pic{flex:none;aspect-ratio:16/9;height:auto;overflow:hidden;border-right:0;border-bottom:1px solid rgba(255,255,255,.28);border-radius:5px 5px 0 0}
  .hp .hx-end-flow[data-hx-row]>.hx-end-step:nth-child(n) .hx-end-pic img{display:block}
  .hp .hx-end-flow[data-hx-row]>.hx-end-step:nth-child(n) .hx-end-no{left:8px;right:auto}
  .hp .hx-end-flow[data-hx-row]>.hx-end-step:nth-child(n) .hx-end-body{align-self:stretch}
}
`;

/* 横の列の矢印 (VoicesShowcase、HxRowArrows、MobileSlideBar)。声の節だけでなく、料金のページの横の列 (料金表、支払い方法、7 段) でも使うので、
   下層のページも読む束 (hp-css.ts の COMMON) に入れる。並びは声の節の束のすぐ前 (声の節の中の hx-arrs-film などの打ち消しが後から効くように) */
export const ROW_ARROWS_CSS = `
.hp .hx-arrbar{display:flex;justify-content:flex-end;margin-top:var(--gap)}
.hp .hx-arrs{display:inline-flex;gap:6px;align-self:center;margin-left:4px}
.hp .hx-arr{display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border:1px solid var(--ink);border-radius:4px;background:#fff;color:var(--ink);cursor:pointer}
@media (max-width:767px){.hp .hx-arr{width:44px;height:44px}}
.hp .hx-arr:hover{background:var(--yellow)}
.hp .hx-arr:focus-visible{outline:2px solid var(--focus-ring);outline-offset:2px}
`;
